<script setup lang="ts">
import GroupIcon from '@/assets/icons/GroupIcon.vue';

defineProps<{
  label: string;
  selected: boolean;
}>();

const emit = defineEmits<{
  select: [];
}>();
</script>

<template>
  <button
    type="button"
    class="popover-option"
    :class="selected && 'bg-highlight'"
    :aria-pressed="selected"
    @click="emit('select')"
  >
    <span class="flex size-8 shrink-0 items-center justify-center rounded-full bg-surface-tint text-tint">
      <GroupIcon class="size-icon-sm" aria-hidden="true" />
    </span>
    <span
      class="min-w-0 flex-1 truncate text-body leading-[1.7]"
      :class="selected ? 'font-semibold text-tint' : 'font-normal text-primary'"
    >
      {{ label }}
    </span>
  </button>
</template>
